import { ITemplateScope } from "AngularFormly";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../records/views/recordGridView";
import { IQService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { MachineConfigurationView } from "../../../models/machineConfiguration";
import {
  SelectRecordModalService,
  vsServiceName as SelectRecordModalServiceName,
} from "../../../../../records/services/selectRecordModal";

interface FormlyTypeSelectMachineScope extends ITemplateScope {
  openMachineModal: () => void;
}

export class FormlyTypeSelectMachineController {
  static $inject = [
    SelectRecordModalServiceName,
    "$scope",
    RecordGridViewServiceName,
    "$q",
    ColumnDefinitionServiceName,
  ];

  constructor(
    private readonly selectRecordModalService: SelectRecordModalService,
    private readonly $scope: FormlyTypeSelectMachineScope,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly $q: IQService,
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {
    this.$scope.openMachineModal = () => this.openMachineModal();
  }

  openMachineModal() {
    const gridConfiguration: GridConfiguration | undefined =
      this.recordGridViewService.getGridConfiguration("machineConfiguration");
    if (!gridConfiguration) {
      throw new Error(
        "Must have machineConfiguration registered with recordGridViewService"
      );
    }

    this.selectRecordModalService.openModal({
      title: "Machines",
      defaultQuery: { CurrentConfiguration: true },
      gridConfiguration,
      onItemSelected: (item, modalInstance) => {
        this.prepareMachineConfigurationView(item);
        const model = this.$scope.model ?? {};
        model[this.$scope.options.key] = item;
        modalInstance.close();
      },
    });
  }
  prepareMachineConfigurationView(
    machineConfigurationView: MachineConfigurationView
  ) {
    const { Id: machineConfigurationId, MachineId: machineId } =
      machineConfigurationView;
    machineConfigurationView.Id = machineId;
    machineConfigurationView.MachineConfigurationId = machineConfigurationId;
  }
}
